import React from 'react'
import { Select, message, Spin } from 'antd'
import { ErrorBoundary } from 'react-error-boundary'
import SearchApi from '../../api/Search'
import debounce from 'lodash/debounce'
import { isEmpty } from 'lodash'
const Option = Select.Option
const api = new SearchApi()

class SearchInput extends React.Component {
  state = {
    data: [],
    value: undefined,
    fetching: false,
  }
  constructor(props) {
    super(props)
    this.fetch = debounce(this.fetch, 800)
  }
  fetch = async (value, callback) => {
    this.setState({ fetching: true })
    try {
      if (isEmpty(value)) callback([])
      const result = await api.search(value)
      const data = []
      result.forEach((r) => {
        data.push(r)
        callback(data)
      })
    } catch (e) {
      message.error(e.message)
    }
    this.setState({ fetching: false })
  }
  handleSearch = (value) => {
    this.fetch(value, (data) => this.setState({ data }))
  }

  handleChange = (value) => {
    this.setState({ value })
  }

  render() {
    const { fetching, data, value } = this.state
    const options = data.map((d) => <Option key={d._id}>{d.title || d.fn}</Option>)
    return (
      <Select
        showSearch
        notFoundContent={fetching ? <Spin size="small" /> : null}
        value={value}
        placeholder="You can search people, documents and more ..."
        style={{ width: '100%' }}
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}>
        {options}
      </Select>
    )
  }
}

export default SearchInput
